import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Navbar from '../components/Navbar';
import Scolarite from '../components/Scolarite';
import Problem from '../components/Problem';
import Solution from '../components/Solution';
import Pricing from '../components/Pricing';
import CollaborationPlan from '../components/CollaborationPlan';
import Team from '../components/Team';
import Projects from '../components/Projects';
import ContactModal from '../components/ContactModal';
import FAQ from '../components/FAQ';
import TechStack from '../components/TechStack';
import StickyLogo from '../components/StickyLogo';
import './HomePage.css';

const HomePage = ({ sector }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="home-page">
      <Navbar onOpenModal={() => setIsModalOpen(true)} />
      <Header sector={sector} onOpenModal={() => setIsModalOpen(true)} />
      {/* <StickyLogo /> */}
      <Scolarite />
      {/* <Problem /> */}
      <Solution />
      <Pricing onOpenModal={() => setIsModalOpen(true)} />
      <Projects />
      <CollaborationPlan onOpenModal={() => setIsModalOpen(true)} />
      <TechStack />
      {/* <Team /> */}
      <FAQ onOpenModal={() => setIsModalOpen(true)} />
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <footer className="footer">
        <div className="container">
          <div className="footer-brand">
            <img src="/photo/logo/logo_myaidgent_balnc_carre_sourire.png" alt="MyAidgent" className="footer-logo" />
            <span className="footer-name">MyAidgent</span>
          </div>
          <div className="footer-content">
            <p>&copy; 2025 MyAidgent. Tous droits réservés.</p>
            <Link to="/confidentialite" className="footer-privacy-link">Politique de confidentialité</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
